import { render, staticRenderFns } from "./areaStatisticsChild.vue?vue&type=template&id=42c581aa&scoped=true&"
import script from "./areaStatisticsChild.vue?vue&type=script&lang=js&"
export * from "./areaStatisticsChild.vue?vue&type=script&lang=js&"
import style0 from "./areaStatisticsChild.vue?vue&type=style&index=0&id=42c581aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c581aa",
  null
  
)

export default component.exports